import type { ReactNode } from 'react';
import type { WeekRowRange } from '../types';

type Props = {
  children: ReactNode;
  weekIndex?: number;
  monthKey?: string;
  weekRowRange?: WeekRowRange;
};

export const WeekRow = ({
  children,
  weekIndex,
  monthKey,
  weekRowRange,
}: Props) => {
  if (weekRowRange && weekIndex != null) {
    if (weekIndex < weekRowRange.start || weekIndex > weekRowRange.end) {
      return null;
    }
  }

  return (
    <div
      data-measure={
        monthKey != null && weekIndex != null
          ? `week-${monthKey}-${weekIndex}`
          : undefined
      }
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        flex: '1 1 0px',
        minHeight: 0,
      }}
    >
      {children}
    </div>
  );
};
